import axios from "../axios";

const api = {
  getDimensions(params, accessToken) {
    const config = {
      params: params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/dimensions", config).then(({ data }) => data);
  },

  getDimensionsHierarchy(params, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/dimensions/hierarchy?${params}`, config).then(({ data }) => data);
  },

  getEntityAppropriateDimensionItems(accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/dimension-items/entities-appropriate`, config).then(({ data }) => data);
  },

  getAssigneeTemplates(accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/organization-questionnaires/assignee-template", config).then(({ data }) => data);
  },

  updateAssigneeTemplate(data, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
    return axios.post("/organization-questionnaires/assignee-template", data, headers).then(({ data }) => data);
  },

  deleteAssigneeTemplate(id, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
    return axios.delete(`/organization-questionnaires/assignee-template?id=${id}`, headers).then(({ data }) => data);
  },
};

export default api;
